import findByString from "../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

const filterDataByString = (data, columns, string) => {
    if (string) {
        return data.filter(o => {
            return columns.some(k => {
                const v = findByString(o, k)
                return v && v.toString().toLowerCase().includes(string.toLowerCase())
            })
        });
    }
    return data;
};

export default filterDataByString;